import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserGroup,
  faIdCardClip,
  faUserPlus,
  faUser,
  faMagnifyingGlass,
  faGear,
  faTag,
  faSquarePlus,
  faHouse,
  faCircleCheck,
  faEllipsis,
  faEllipsisVertical,
  faXmark,
  faLocationDot,
  faGlobe,
  faHandshake,
  faIdBadge,
  faUsers,
  faUsersViewfinder,
  faTrophy,
  faPen,
  faWrench,
  faCircleInfo,
  faCircleQuestion,
  faCircleUser,
  faUserGear,
  faEnvelope,
  faUserMagnifyingGlass,
  faCircleXmark,
  faFloppyDisk,
  faEye,
  faPlus,
  faMinus,
  faLockKeyhole,
  faTriangleExclamation,
  faArrowLeftToLine,
} from "@fortawesome/sharp-solid-svg-icons";

import {
  faLockKeyhole as faLockOutline,
  faLockKeyholeOpen as faLockOpenOutline,
} from "@fortawesome/sharp-regular-svg-icons";
import { SvgIcon } from "@mui/material";

import { ReactComponent as GWLogo } from "./gwlogo.svg";

const defaultSize = 22;

export function GWWarhammerIcon(props) {
  return (
    <SvgIcon>
      <GWLogo />
    </SvgIcon>
  );
}

export function BCPArrowLeftToLine(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faArrowLeftToLine}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPCircleCheck(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faCircleCheck}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPCircleInfo(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faCircleInfo}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPCircleQuestion(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faCircleQuestion}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPCircleUser(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faCircleUser}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPCircleXmark(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faCircleXmark}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPEllipsis(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faEllipsis}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPEllipsisVertical(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faEllipsisVertical}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPEnvelope(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faEnvelope}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPEye(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faEye}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPFloppyDisk(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faFloppyDisk}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPHandshake(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faHandshake}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPHouse(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faHouse}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPGear(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faGear}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPGlobe(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faGlobe}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPIdBadge(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faIdBadge}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPIdCardClip(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faIdCardClip}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPLocationDot(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faLocationDot}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPLockKeyhole(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faLockKeyhole}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPLockOutline(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faLockOutline}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPLockOpenOutline(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faLockOpenOutline}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPMinus(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faMinus}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPPen(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faPen}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPPlus(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faPlus}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPSearch(props) {
  const { sx, style, ...rest } = props;
  const size = 18;

  return (
    <FontAwesomeIcon
      icon={faMagnifyingGlass}
      style={{
        fontSize: `${size}px`,
        width: `${size}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPSquarePlus(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faSquarePlus}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPTag(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faTag}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPTriangleExclamation(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faTriangleExclamation}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPTrophy(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faTrophy}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPUser(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faUser}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPUserGear(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faUserGear}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPUsers(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faUsers}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPUsersViewfinder(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faUsersViewfinder}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPUserGroup(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faUserGroup}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPUserMagnifyingGlass(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faUserMagnifyingGlass}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPUserPlus(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faUserPlus}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPWrench(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faWrench}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}

export function BCPXmark(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faXmark}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}
